module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- <div class="label">'+
((__t=( obj.domain ))==null?'':__t)+
'</div>\n -->\n\n\n			<div class="filter-group__label">'+
((__t=( obj.prependedText ))==null?'':__t)+
' </div>\n			<div class="filter-group__container">\n				<div class="filter-group__button">\n					<div class="filter-group-button__label js-group-button-label">'+
((__t=( getFieldLabel() ))==null?'':__t)+
'</div>\n					<div class="filter-group-button__remove js-remove"></div>\n				</div>\n				<div class="filter-popup js-filter-popup ';
 if (obj.popupVisible) { 
__p+=' is-visible ';
 } 
__p+=' multi-select filter-type__'+
((__t=( obj.type ))==null?'':__t)+
'">\n					<div class="filter-popup__header">\n						<div class="filter-popup__title">Filter by '+
((__t=( obj.domain ))==null?'':__t)+
'</div>\n					</div>\n					<div class="filter-popup__body filter-body__region">\n					</div>\n					<div class="filter-popup__footer">\n						<a class="m-btn m-btn--primary js-apply">apply</a>\n					</div>\n\n				</div>\n\n			</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/components/devices-filter/templates/filter.html
// module id = 405
// module chunks = 0